(function () {
  var root = document.documentElement;
  var loader = document.getElementById('dd-loader');
  if (!loader || !root.classList.contains('dd-loading')) return;

  var stack = document.getElementById('dd-loader-logo');
  var fill = document.getElementById('dd-loader-fill');
  var MIN = 1600;   // the bar always takes at least this long (ms)
  var MAX = 9000;   // safety: never keep anyone waiting longer than this (ms)
  var start = performance.now();
  var shown = 0;
  var finished = false;

  // How loaded the page really is (on Home, also waits for the first video)
  function realProgress() {
    var s = document.readyState;
    var p = s === 'complete' ? 100 : (s === 'interactive' ? 80 : 55);
    if (document.querySelector('[data-dd-wait]') && !window.__ddHomeReady) p = Math.min(p, 90);
    return p;
  }

  function done() {
    root.classList.remove('dd-loading');
    loader.remove();
  }

  // Where the logo lands: the left bar logo on PC, otherwise the header logo
  function destination() {
    if (root.classList.contains('cd-side-open') && window.innerWidth >= 750) {
      var side = document.querySelector('.cd-drawer__logo-img');
      if (side && side.offsetWidth > 0) return side;
    }
    return document.querySelector('.cd-logo__img--light') || document.querySelector('.cd-logo img');
  }

  // Swoosh the loader logo into place
  function finish() {
    if (finished) return;
    finished = true;
    try { sessionStorage.setItem('ddLoaded', '1'); } catch (e) {}

    var dest = destination();
    var from = stack.getBoundingClientRect();

    loader.classList.add('is-leaving');
    stack.classList.add('is-moving');

    if (dest) {
      var to = dest.getBoundingClientRect();
      if (to.width > 0 && from.width > 0) {
        var scale = to.width / from.width;
        var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
        var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
        stack.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
      }
    }
    setTimeout(done, 1050);
  }

  function tick(now) {
    var elapsed = now - start;
    var timeCap = Math.min(100, (elapsed / MIN) * 100);
    var goal = Math.min(realProgress(), timeCap);
    if (elapsed > MAX) goal = 100;

    shown += (goal - shown) * 0.12;
    if (goal >= 100 && shown > 99.5) shown = 100;
    fill.style.width = shown + '%';

    if (shown >= 100) { setTimeout(finish, 150); return; }
    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
})();